import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './menu-fixes.css'
import './modal-fixes.css'
import './quill-fixes.css'
import './nimbus-premium.css'
import './policy-editor.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
